import * as yup from "yup"
import type { Document } from "../../types"

export function initialValuesDocument(document?: Document | undefined) {
  if (document) {
    return document
  }
  return {
    title: "",
    description: "",
    highlighted: false,
    
    authors: [],
    editors: [],
    producers: [],
    photographers: [],
    designers: [],
    formats: [],
    typologies: [],
    year: undefined,
    date_generic: undefined,
    event_year: undefined,
    source_urls: [],
    municipalities: [],
    draft: false,
  }
}

export function validationSchemaDocument() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    description: yup.string().required("Campo obbligatorio"),
  })
}
